export default "__VITE_ASSET__Dfr90Sbd__"